<template>
<div class="content">

    <div class="form-group">
        <label>delete nodes above threshold check</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    <input type="checkbox" id="delete_nodes_above_threshold_check" v-model="
                                    form.delete_nodes_above_threshold_check
                                " />
                </div>
            </div>
            <input type="number" class="form-control" name="r_step" v-model="form.delete_nodes_above_threshold" :class="
                            form.errors.delete_nodes_above_threshold_check
                                ? 'is-invalid'
                                : ''
                        " />
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                            .delete_nodes_above_threshold">
                {{ error }}
            </span>
        </div>
    </div>

    <!-- delete_nodes_below_threshold_check -->
    <div class="form-group ">
        <label>delete nodes below threshold</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    <input type="checkbox" id="delete_nodes_below_threshold_check" v-model="
                                    form.delete_nodes_below_threshold_check
                                " />
                </div>
            </div>
            <input type="number" class="form-control" :class="
                            form.errors.delete_nodes_below_threshold
                                ? 'is-invalid'
                                : ''
                        " name="r_step" v-model="form.delete_nodes_below_threshold" />
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                            .delete_nodes_below_threshold">
                {{ error }}
            </span>
        </div>
    </div>

    <!-- delete_lines_above_threshold_check -->
    <div class="form-group ">
        <label>delete lines above threshold</label>

        <div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    <input type="checkbox" id="delete_lines_above_threshold_check" v-model="
                                    form.delete_lines_above_threshold_check
                                " />
                </div>
            </div>
            <input type="number" class="form-control" name="r_step" v-model="form.delete_lines_above_threshold" :class="
                            form.errors.delete_lines_above_threshold
                                ? 'is-invalid'
                                : ''
                        " />
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                            .delete_lines_above_threshold">
                {{ error }}
            </span>
        </div>
    </div>

    <!-- delete_lines_below_threshold_check -->
    <div class="form-group ">
        <label>delete lines below threshold</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    <input type="checkbox" id="delete_lines_below_threshold_check" v-model="
                                    form.delete_lines_below_threshold_check
                                " />
                </div>
            </div>
            <input type="number" class="form-control" name="r_step" v-model="form.delete_lines_below_threshold" :class="
                            form.errors.delete_lines_below_threshold
                                ? 'is-invalid'
                                : ''
                        " />
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                            .delete_lines_below_threshold">
                {{ error }}
            </span>
        </div>

    </div>
</div>
</template>

<script>
export default {
    props: ["form"],
}
</script>
